module.exports = __webpack_public_path__ + "img/felix_gumbsch_9.e6a314be.jpg";